
import { xCore } from './core';
import { NSServerCalls } from './utils/servercalls.js'
import { NSMessages } from './utils/messages.js';

import { Overlays as NSMapLayersManager } from './overlays.js'
import { NSObjDetails } from './obj_details'
import { NSObjDetailsCreate } from './obj_details_create'


import jQuery_LOCAL from "jquery";
import { NSFeaturesSelect } from './map_features_select';
import { URN as NSURN } from './utils/urn';

var  $ = jQuery_LOCAL;




export let LayersTree = {

	//public methods:
	f_get_bst_node_by_geoserver_layer_name: function(s_geoserver_layer_name)
	{
		return this.page_objs.o_global_tree_struct.f_get_bst_node_by_geoserver_layer_name(s_geoserver_layer_name);
	},

	f_select_layer_by_geoserver_layer_name: function(s_geoserver_layer_name)
	{
		let b_layers_is_selected = this.page_objs.o_global_tree_struct.f_layer_is_selected_by_layer_name(s_geoserver_layer_name);
		if(!b_layers_is_selected)
		{
			let o_bst_node = this.page_objs.o_global_tree_struct.f_get_bst_node_by_geoserver_layer_name(s_geoserver_layer_name);
			let o_tree_view = this.page_objs.o_global_tree_struct.o_tree_view;
			o_tree_view.selectNode(o_bst_node, { silent: true });
			this.o_tree_struct.f_select_node(null, o_bst_node);
		}
		else
		{
			console.log("layer already IS selected!!!!!");
		}
	},

	f_unselect_layer_by_geoserver_layer_name: function(s_geoserver_layer_name)
	{
		let b_layers_is_selected = this.page_objs.o_global_tree_struct.f_layer_is_selected_by_layer_name(s_geoserver_layer_name);
		if(b_layers_is_selected)
		{
			let o_bst_node = this.page_objs.o_global_tree_struct.f_get_bst_node_by_geoserver_layer_name(s_geoserver_layer_name);
			let o_tree_view = this.page_objs.o_global_tree_struct.o_tree_view;
			o_tree_view.unselectNode(o_bst_node, { silent: true });	
			this.o_tree_struct.f_unselect_node(null, o_bst_node);
		}
		else
		{
			console.log("layer IS NOT selected!!!!!");
		}
	},

	/**
	 * 
	 * @param {string} s_geoserver_layer_name geoserver layer name (without workspace, ex: "arvore____nao_abatidas")
	 * @returns {LayersTree.objs.TreeNode}
	 */
	f_get_tree_node_cfg_by_geoserver_layer_name: function(s_geoserver_layer_name)
	{
		let o_bst_node = this.page_objs.o_global_tree_struct.f_get_bst_node_by_geoserver_layer_name(s_geoserver_layer_name);
		if(o_bst_node != null)
		{
			let i_node_id = o_bst_node._custom_data_.id;
				  
			let o_node = LayersTree.page_objs.o_tree_node_struct.f_get_element_by_id(i_node_id);
			return o_node;
		}
	},


	page_objs: 
	{
		o_tree_node_struct:
		{
			a_tree_node: new Array(), //[LayersTree.objs.TreeNode]
			
			f_get_element_by_id: function (i_id)
			{
				var a_ = this.a_tree_node;
				
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					if(o_i.id == i_id)
					{
						return o_i;
					}
					
				}
			},
			f_get_elements_by_id_list: function (a_i_id)
			{
				var a_res = [];
				
				var a_ = a_i_id;
				
				for(var i=0; i<a_.length; i++)
				{
					var i_id = a_[i];
					var o_i = this.f_get_element_by_id(i_id)
					a_res.push(o_i);
					
				}
				return a_res;
			},
			f_get_elements_by_parent_id: function (i_parent_id)
			{
				var a_ = this.a_tree_node;
				var a_res = new Array();
				
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					if(o_i.parent_id == i_parent_id)
					{
						a_res.push(o_i);
					}
				}
				return a_res;
			},
			f_get_elements_with_no_parent: function()
			{
				return this.f_get_elements_by_parent_id(null);
			},
			f_get_parent_by_leaf_dataset_and_collection: function(s_data_set_internal_name, s_collection_internal_name)
			{
				var o_parent = null;
				var o_elem = null;
				//"swrefVdataset_collectionVdatasetZmunicipioVcollectionZmn_unidade_hoteleira"
				var s_urn = "swrefVdataset_collectionVdatasetZ" + s_data_set_internal_name + "VcollectionZ" + s_collection_internal_name;
				
				var a_ = this.a_tree_node;
				
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					if(
						o_i.tree_node_type_id == 2 //leaf
						&& o_i.urn == s_urn
					)
					{
						o_elem = o_i;
						break;
					}
				}
				
				if(o_elem != null)
				{
					o_parent = this.f_get_element_by_id(o_elem.parent_id);	
				}
				
				return o_parent;
				
			},
			f_sort: function()
			{
				var a_ = this.a_tree_node;
				
				var f = function(o_a,o_b){
					var i_a_nt = (parseInt(o_a.tree_node_type_id))? parseInt(o_a.tree_node_type_id) : "Not a number";
					var i_b_nt = (parseInt(o_b.tree_node_type_id))? parseInt(o_b.tree_node_type_id) : "Not a number";
					
					if(i_b_nt == "Not a number")
					{
						return -1;
					}
					else if(i_a_nt == "Not a number")
					{
						return 1;
					}
					else if(i_a_nt>i_b_nt)
					{
						return 1;
					}
					else if(i_a_nt<i_b_nt)
					{
						return -1;
					}
					
					var i_a_order = (parseInt(o_a.order))? parseInt(o_a.order) : "Not a number";
					var i_b_order = (parseInt(o_b.order))? parseInt(o_b.order) : "Not a number";
					
					if(i_b_order == "Not a number")
					{
						return -1;
					}
					else if(i_a_order == "Not a number")
					{
						return 1;
					}
					else if(i_a_order>=i_b_order)
					{
						return 1;
					}
					else
					{
						return -1;
					}
				}
				a_.sort(f);
			}
		},
			
		o_global_tree_struct: 
		{
			s_e_tree_id: 'layerpage_content', //'layerpage',//"layerpage_content",//"layerpage",//div_tree_holder",
			e_tree: null,
			o_tree_view: null,
			a_BST_all_nodes: [],
			f_get_selected_id_list: function()
			{
				var a_id = [];
				
				var a_selected_objs = this.o_tree_view.getSelected();
				var a_ = a_selected_objs;
				for(var i=0; i<a_.length; i++)
				{
					var o_i =  a_[i];
					var i_id = o_i._custom_data_.id;
					
					a_id.push(i_id);
				}
				return a_id;
			},
			f_get_bst_node_by_geoserver_layer_name: function(s_geoserver_layer_name)
			{
				
  				let o_bstn = this.a_BST_all_nodes.find(o_bstn_i => o_bstn_i._custom_data_.geoserver_layer_name == s_geoserver_layer_name);
				return o_bstn;
			},
			f_layer_is_selected_by_layer_name: function(s_geoserver_layer_name)
			{
				let a_selected = LayersTree.page_objs.o_global_tree_struct.o_tree_view.getSelected();
				let b_layer_is_selected = (a_selected.find(o_bstn_i => o_bstn_i._custom_data_.geoserver_layer_name == s_geoserver_layer_name) != null);
				return b_layer_is_selected;
			}
			
		}
		
		
	},

	init: function()
	{	
		var this_ = this;	

		let o_promise_result = new Promise((resolve, reject) => 
			{
				
				var f_cb = function ()
				{
					this_.o_tree_struct.f_build_tree();
					resolve();
				}
				
				this.o_load_data_struct.f_load_data(f_cb);


			}
		);

		return o_promise_result;
	},
	
	o_load_data_struct: {
		
		f_load_data: function (f_cb)
		{
			this.f_load_tree_node_data_(f_cb);
			
		},
		
		f_load_tree_node_data_: function(f_cb_in)
		{
			var this_ = this;
			
			var f_cb = function(o_res)
			{
				this_.f_load_layer_detail_process_res_(o_res);
				f_cb_in();
			}
			

			NSServerCalls.f_get_tree_node_data(f_cb);
	
		},
		f_load_layer_detail_process_res_: function(o_res)
		{
			var o_tree_node_struct = LayersTree.page_objs.o_tree_node_struct;
			
			var b_error = false;
			try
			{
				//o_tree_node_struct.a_tree_node = LayersTree.data.a_tree_node;
				o_tree_node_struct.a_tree_node = o_res.tree_layers.a_tree_node;
				
				o_tree_node_struct.f_sort();
				
			}
			catch(e)
			{
				b_error = true;
			}
			
			if(b_error)
			{
				var s_msg = "Erro no carregamento dos dados da árvore.";
				var i_time_out = 5000;
				NSMessages.f_show_error(s_msg, i_time_out);
				
			}
			
			
		},
	},
	
	o_tree_struct: {

			// [NSObjDetailsCreate.objs.LeafCreateButtonData]
			a_leaf_create_button_info: [],
		
		f_build_tree: function()
		{
			
			var this_ = this;
			
			var o_tree_node_struct = LayersTree.page_objs.o_tree_node_struct;
	
			var o_data_node_root = {
					id: "root",
						parent_id: null,
						tree_node_type_id: 1, //branch
						external_name: "Temas"
			}
			
			var a_bstn_child = new Array();
			var a_level_1_nodes = o_tree_node_struct.f_get_elements_with_no_parent();
			var a_ = a_level_1_nodes;
			for(var i=0; i<a_.length; i++)
			{
				var o_i = a_[i];
				var o_bstn_child = this_.f_build_tree_process_datanode_and_create_BoostrapTreeNode(o_i);
				a_bstn_child.push(o_bstn_child);	
			}
			
			
			/*
			//(  B E G I N  )-- to use branch "temas" ---(  B E G I N  ) -------------------------------------
			*/
			
			var a_tree_data = [];
			//create BootstrapTreeNode
			var o_bstn_root = this_.f_create_bootstrap_tree_node(o_data_node_root, a_bstn_child);
			a_tree_data.push(o_bstn_root);
			/*
			//(  E N D  )------ to use branch "temas" ---(  E N D  ) -------------------------------------
			*/
			
			/*
			//to remove branch "temas"
			var a_tree_data = a_bstn_child;
			*/
			
			
			var o_global_tree_struct = LayersTree.page_objs.o_global_tree_struct;
			o_global_tree_struct.e_tree = document.getElementById(o_global_tree_struct.s_e_tree_id);

			var e_tree = $('<div></div>');

			e_tree.treeview(
				{
					data: a_tree_data, 
					levels: 2,
					multiSelect: true
				});
			var o_tree_view = e_tree.treeview(true);
			o_global_tree_struct.o_tree_view = o_tree_view;
			o_global_tree_struct.a_BST_all_nodes = o_tree_view.getUnselected();	// storing all nodes for later operations
			

			e_tree.on('nodeSelected', function(event, data) {
			  // Your logic goes here
			  //alert("tree select!");
			  /*
			  console.log('Node selected!');
			  console.log(event);
			  console.log(data);
			  console.log(data._custom_data_.urn);
			  */
			  
			  
			  var o_bstn = data;
			  this_.f_select_node(event, data);
			});
			
			e_tree.on('nodeUnselected', function(event, data) {
			  // Your logic goes here
			  //alert("tree select!");
			  /*console.log('Node unselected!');
			  console.log(event);
			  console.log(data);
			  console.log(data._custom_data_.urn);*/
			  var o_bstn = data;
			  this_.f_unselect_node(event, data);
			});
			
			e_tree.on('nodeExpanded', function(event, data) {
				// Your logic goes here
			  });
			  
			e_tree.on('renderEnd', function(event, data) {
				// Your logic goes here
				//alert("tree renderEnd!");
				/*
				console.log('renderEnd!');
				console.log(event);
				console.log(data);*/
				//var o_bstn = data;
				
				/*
					A função f_init_leaf_nodes_create_button_click tem de ser chamado neste evento adicionado 
					à biblioteca porque o evento 'nodeExpanded' dispara antes dos elementos da tree serem recriados.
					Quando este evento ('renderEnd') dispara ( o que acontece com frequência pois a biblioteca está sempre 
					a recriar os elementos) os elementos já estão criados.
				*/
				this_.f_init_leaf_nodes_create_button_click();
			  });

			
			$(o_global_tree_struct.e_tree).append(e_tree);

		},
		f_init_leaf_nodes_create_button_click: function()
		{
			// Init leaf nodes onclick events:

			// [NSObjDetailsCreate.objs.LeafCreateButtonData]
			this.a_leaf_create_button_info.forEach(
				(leaf_button_info) => {
					if(leaf_button_info.elem_id != null)
					{
						let elem = document.getElementById(leaf_button_info.elem_id);
						if(elem != null)
						{
							elem.onclick = function(event)
							{
								//onclick="NSObjDetailsCreate.reserved.o_buttons.f_button_click(event, this);"
								NSObjDetailsCreate.reserved.o_buttons.f_button_click(event, elem);
							};
						}
					};

				}
			);

		},
		f_select_node: function(event, data)
		{
			//console.log('Node selected!');
			  //console.log(event);
			  //console.log(data);
			  //console.log(data._custom_data_.id);
			  
			  this.f_highlight_parents(data);

			  var i_node_id = data._custom_data_.id;
			  
			  var o_node = LayersTree.page_objs.o_tree_node_struct.f_get_element_by_id(i_node_id);
			  
			  //NSMapLayersManager.f_add_layer(i_node_id);
			  NSMapLayersManager.f_add_layer(o_node);

			  NSFeaturesSelect.f_update_layer_highlight(o_node.urn);
		},
		f_unselect_node: function(event, data)
		{
			//console.log('Node unselected!');
			//console.log(event);
			//console.log(data);
			//console.log(data._custom_data_.id);
			
			this.f_unselect_reset_parents_highlight(data); 

			var i_node_id = data._custom_data_.id;

			var o_node = LayersTree.page_objs.o_tree_node_struct.f_get_element_by_id(i_node_id);
			
			//NSMapLayersManager.f_remove_layer(i_node_id);
			NSMapLayersManager.f_remove_layer(o_node);

			NSObjDetails.f_hide_read_and_edit_section_if_they_belong_to_disabled_table(o_node.urn);

			NSFeaturesSelect.f_update_layer_highlight(o_node.urn);
			//NSInfoWindow.f_close_infowindow_if_belongs_to_disabled_collection(s_collection_urn); AQUIIIIIII TODO TO DO
		},
		f_highlight_parents: function(o_bstn)
		{
			/*
			notes:
			o_tree_view
				getNode(nodeId)
				selectNode(node | nodeId, options)				-> { silent: true } so select event won't be trigged
				unselectNode(node | nodeId, options)			-> { silent: true } so unselect event won't be trigged
				
			o_node
				nodeId
				parentId
				
				._custom_data_
					.i_node_active_descendants_count: 0
			*/
			let o_global_tree_struct = LayersTree.page_objs.o_global_tree_struct;
			let o_tree_view = o_global_tree_struct.o_tree_view;			
			
			var i_parent_id = o_bstn.parentId;
			
			var o_parent_node = o_tree_view.getNode(i_parent_id);
			if(o_parent_node != null)
			{
				o_tree_view.selectNode(o_parent_node, { silent: true });
				o_parent_node._custom_data_.i_node_active_descendants_count++;
				this.f_highlight_parents(o_parent_node); 
			}
			
			
		},
		f_unselect_reset_parents_highlight: function(o_bstn)
		{
			let o_global_tree_struct = LayersTree.page_objs.o_global_tree_struct;
			let o_tree_view = o_global_tree_struct.o_tree_view;	

			var i_parent_id = o_bstn.parentId;
			
			var o_parent_node = o_tree_view.getNode(i_parent_id);
			if(o_parent_node != null)
			{
				o_parent_node._custom_data_.i_node_active_descendants_count--;
				if(o_parent_node._custom_data_.i_node_active_descendants_count == 0)
				{
					o_tree_view.unselectNode(o_parent_node, { silent: true });	
				}
				
				this.f_unselect_reset_parents_highlight(o_parent_node); 
			
			}
			
		},
		f_destroy_tree: function()
		{
			var o_global_tree_struct = LayersTree.page_objs.o_global_tree_struct;
			if(o_global_tree_struct.e_tree != null)
			{
				o_global_tree_struct.e_tree.innerHTML = "";
			}
			o_global_tree_struct.e_tree = null;
			o_global_tree_struct.o_tree_view = null;
			
		},
		f_build_tree_process_datanode_and_create_BoostrapTreeNode: function (o_node_in)
		{
			var o_tree_node_struct = LayersTree.page_objs.o_tree_node_struct;
			var b_node_branch = (o_node_in.tree_node_type_id == 1) ? true : false;
			
			
			var a_bstn_child = new Array();
			if(b_node_branch)
			{
				var a_child_nodes = o_tree_node_struct.f_get_elements_by_parent_id(o_node_in.id);
				var a_ = a_child_nodes;
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					var o_bstn_child = this.f_build_tree_process_datanode_and_create_BoostrapTreeNode(o_i);
					a_bstn_child.push(o_bstn_child);
				}
			}
			
			//create BootstrapTreeNode
			var o_bstn = this.f_create_bootstrap_tree_node(o_node_in, a_bstn_child);
			
			
			return o_bstn;
		},
		f_create_bootstrap_tree_node: function (o_data_node_in, a_bstn_child_in)
		{
			var o_bstn;
			var b_node_branch = (o_data_node_in.tree_node_type_id == 1) ? true : false;
			if(b_node_branch)
			{
				o_bstn = 
						{
							_custom_data_: 
							{
								id: o_data_node_in.id,
								
								
								i_node_active_descendants_count: 0
							},
							text: o_data_node_in.external_name,
							selectable: false,
							nodes: a_bstn_child_in
						};
			}
			else // leaf
			{
				var s_icon_path = "";
				var s_icon = "";
				var s_create_button = "";
				var s_urn = o_data_node_in.urn;
				
				if(o_data_node_in.icon != null && o_data_node_in.icon!= "")
				{
					s_icon = '<img src="' + xCore.application.layer_images_base_path + '/' + o_data_node_in.icon + '" alt="loading">'
				}
				
				/*
					s_urn -> collection urn
					s_create_button -> is not empty only if user has permissions
				*/
				if(s_urn != null && s_urn != "")
				{
					//s_create_button = NSObjDetailsCreate.f_get_tree_button_create_HTML(s_urn);	
					// [NSObjDetailsCreate.objs.LeafCreateButtonData]
					let leaf_create_button_info = NSObjDetailsCreate.f_get_tree_button_create_HTML(s_urn);
					this.a_leaf_create_button_info.push(leaf_create_button_info);
					s_create_button = leaf_create_button_info.s_HTML;
				}

				let s_geoserver_layer_name;
				if (o_data_node_in.geo_server_layer_name != null && o_data_node_in.geo_server_layer_name != '')
				{
					s_geoserver_layer_name = o_data_node_in.geo_server_layer_name;
				}
				else if(s_urn != null && s_urn != "")
				{
					s_geoserver_layer_name = NSURN.f_get_urn_table_name(s_urn);
				}
				
				o_bstn = 
				{
					_custom_data_: 
					{
						'id': o_data_node_in.id,
						"geoserver_layer_name": s_geoserver_layer_name
					},
					//text: s_icon + o_data_node_in.external_name,
//					text: s_create_button + " " + o_data_node_in.external_name ,
//					text: '<div test="test" style="display:inline;"><span style="float:left;">' + o_data_node_in.external_name + '</span><div style="float:right;">' + s_create_button + '</div></div>',
//					text: o_data_node_in.external_name + '<div class="vertical_center" style="position: absolute; right: 5px;">' + s_create_button + '</div>',
					text: o_data_node_in.external_name + '<div class="div_tree_create_obj_button">' + s_create_button + '</div>',
//					text: o_data_node_in.external_name ,
					selectable: true,
					//nodes: []
					
					//icon: NSConfig.paths.layer_images + "/" + o_data_node_in.icon,
					//icon: "glyphicon glyphicon-stop",
					//selectedIcon: "glyphicon glyphicon-stop",
				};

			}
			return o_bstn;
		}
		
	}
	
	
	
};
LayersTree.objs = {};

/*
o_in:

--Branch:

	id
	tree_node_type_id (1->branch)
	parent_id
	external_name
	order
 

--Leaf:
	id
	tree_node_type_id (2->leaf)
	parent_id
	external_name
	order

	type (Vector ||...)
	urn
	geometry_urn
	icon
	centroid
	centroid_max_zoom
	visibility_min_zoom
	style
	tile_url



*/
LayersTree.objs.TreeNode = function (o_in)
{

	this.id = o_in.id;
	this.tree_node_type_id = o_in.tree_node_type_id;
	this.parent_id = o_in.parent_id;
	this.external_name = o_in.external_name;
	this.order = o_in.order;
	this.type = o_in.type;
	this.urn = o_in.urn;
	this.geometry_urn = o_in.geometry_urn;
	this.icon = o_in.icon;
	
	this.tile_url = o_in.tile_url;
}




window.LayersTree_ = LayersTree;